__turbopack_context__.v({
  "wrapper": "Jvt4ZG_wrapper",
});
